import { useStore } from 'providers';
import { OnboardingAction, OnboardingData } from 'models';
import FoodInterests from './FoodInterests';
import HowItWorksOnboarding from './HowItWorksOnboarding';
import DateOfBirth from './DateOfBirth';
import RestaurantLocation from './RestaurantLocation';
import ReferAFriend from './ReferAFriend';
import MarketingPreferences from './MarketingPreferences';

interface OnboardingSlide {
  id: string;
  title: string;
  subtitle: string;
  shouldValidate?: boolean;
  shouldSubmit?: boolean;
  component: (props: any) => JSX.Element;
}

export const slideReducer = (
  onboardingData: OnboardingData,
  action: OnboardingAction
): OnboardingData => {
  const { type, data } = action;
  const { buttonState, surveyAnswers, referralCode, referralCodeError, marketingOptIn } = data;

  const updatedData = {
    setButtonState: { ...onboardingData, buttonState },
    setSurveyAnswers: { ...onboardingData, surveyAnswers },
    setReferralCode: { ...onboardingData, referralCode },
    setReferralCodeError: { ...onboardingData, referralCodeError },
    setMarketingOptIn: { ...onboardingData, marketingOptIn },
  };

  return updatedData[type] as OnboardingData;
};

export const useOnboardingSlides = () => {
  const { store } = useStore();
  const { surveyQuestions } = store;

  const { dietaryPreferences, DOB, favouriteRestaurant } = surveyQuestions || {};

  const slides: OnboardingSlide[] = [
    {
      id: 'Welcome',
      title: "Welcome to the Zillionaires' Club! Here's how it works:",
      subtitle: '',
      component: HowItWorksOnboarding,
    },
    {
      id: 'Food Interests',
      title: dietaryPreferences.questionText,
      subtitle: '…this way we can find the best Perkz just for you!',
      component: FoodInterests,
    },
    {
      id: 'Date of Birth',
      title: DOB.questionText,
      subtitle: '…so we can share something special with you!',
      component: DateOfBirth,
    },
    {
      id: 'Favourite Restaurant',
      title: favouriteRestaurant.questionText,
      subtitle: '…so we can keep you in the loop with all their latest news',
      component: RestaurantLocation,
    },
    {
      id: 'Refer a Friend',
      title: '(Optional) Do you have a referral code from a friend?',
      subtitle: "…so we can reward them once you've made your first visit",
      shouldValidate: true,
      component: ReferAFriend,
    },
    {
      id: 'Marketing Preferences',
      title: 'Let us email you about free food & offers',
      subtitle: '',
      shouldSubmit: true,
      component: MarketingPreferences,
    },
  ];

  return slides;
};
